import React, { useState } from 'react';
import Sidebar from './Sidebar';
import ChatWindow from './ChatWindow';
import styles from './ChatApp.module.css';

const ChatApp = () => {
  const [selectedUser, setSelectedUser] = useState(null);

  return (
    <div className={styles.chatApp}>
      <Sidebar onSelectUser={setSelectedUser} />
      <ChatWindow user={selectedUser} />
    </div>
  );
};

export default ChatApp;